"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendSMS = void 0;
var HttpClient_1 = require("../core/HttpClient");
var SendSMS = function (smsData) {
    return HttpClient_1.HttpClient.post('/notifications', smsData);
};
exports.SendSMS = SendSMS;
